import React from 'react';
import MUIGrow, { GrowProps as MUIGrowProps } from '@material-ui/core/Grow';

interface GrowProps extends MUIGrowProps {}

const Grow = (props: GrowProps) => {
  return <MUIGrow {...props}>{props.children}</MUIGrow>;
};

Grow.displayName = 'Grow';

export default Grow;
